import React, {Component} from 'react';
import { Row, Col, FormControl } from 'react-bootstrap';
import { Checkbox, Radio } from 'react-icheck';
import PrintPreview from './PrintPreview';
import PdfStore from '../../stores/PdfStore';
import WorkdocStore from '../../stores/WorkdocStore';
import TextFieldModal from '../../component/element/TextFieldModal'

var NotificationSystem = require('react-notification-system');
class PrintCarSummaryDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = {loading:false,data:{pdf_config:{show_signature:false},car:{car_registration_no:'',brand:'',model:'',car_no:'',vehicle_code:'',province:'',year:'',chassis_no:'',engine_no:''},
        owner:{name:''},
        insurer:{insurer_id:'',insurer_name:''},receiving:{appointment_date:''},delivering:{delivering_date:''},
        summary:{income:{},expense:{}},
        related_detail:{profit:'',expense_amount:'',income:{auction_price:'',price:'',quotation_price:'',final_price:'',received_amount:''},expense:{office_wage:'',daily_wage:'',seat_wage:'',eletronic_wage:'',air_wage:'',machine_wage:'',contractor_wage:'',suspension_wage:'',assemble_wage:'',paint_wage:'',smith_wage:'',sand_shot_wage:'',part_price:'',steel_price:'',color_price:'',oil_price:'',other:''}}}
    }

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('portrait');
  }

  componentDidMount(){
    this._notificationSystem = this.refs.notificationSystem;

    let {data} = this.state
    let that = this
    this.setState({loading:true})
     PdfStore.loadCarSummaryDoc(this.props.workNo,function(result){
      let newData = result.data
      newData['insurer'] = Object.assign(data.insurer,newData.insurer)
      newData['car'] = Object.assign(data.car,newData.car)
      newData['owner'] = Object.assign(data.owner,newData.owner)
      newData['receiving'] = Object.assign(data.receiving,newData.receiving)
      newData['delivering'] = Object.assign(data.delivering,newData.delivering)
      newData['related_detail'] = Object.assign(data.related_detail,newData.related_detail)
      newData['pdf_config'] = Object.assign(data.pdf_config,newData.pdf_config)
      that.setState({loading:false,data:newData})
     },function(){
      that.setState({loading:false})
     })
  }

  // renderLogoUrl(logoUrl){
  //   let imgUrl = ''
  //   if (process.env.NODE_ENV == "development") {
  //     imgUrl = 'https://demo2.bigfix.co/korat/pdf/'+logoUrl
  //   }else{
  //     imgUrl = '../'+logoUrl
  //   }
  //   return (<img src={imgUrl} />)
  // }

  getNumberFormat(val) {
    if (val!==''&&val!==null&&val!==undefined) {
      val = val.replace(",", "");
      if(!isNaN(val))
        return parseFloat(val).toLocaleString(undefined, {maximumFractionDigits: 2}) 
      else
        return ''
    }
    return ''
  }

  renderComponentPage(){
    let {car,owner,insurer,receiving,delivering,summary,pdf_config} = this.state.data    
    let {income,expense,expense_amount,profit} = summary
    return (
      <div className='font-print'>
        <div>
          <table className='table table-print-car-summary-doc'>
            <tbody>
              <tr>
                <td className='text-center bg-green' colSpan={3}>
                  <h1 className='color-pink'>{car.car_registration_no} {car.province}</h1>
                </td>
              </tr>
              <tr>
                <td className='text-center' colSpan={2}>ลำดับ</td>
                <td className='text-center bg-green'>{this.props.workNo}</td>
              </tr>
              <tr>
                <td className='text-center'>ว/ด/ป</td>
                <td className='text-center'>รับรถ</td>
                <td className='text-center'>{receiving.entrance_date}</td>
              </tr>
              <tr>
                <td className='text-center'></td>
                <td className='text-center color-pink'>กำหนดรถ ออก</td>
                <td className='text-center color-pink'>{receiving.appointment_date}</td>
              </tr>
              <tr>
                <td className='text-center'>ว/ด/ป</td>
                <td className='text-center'>รับออก</td>
                <td className='text-center'>{delivering.delivering_date}</td>
              </tr>
            </tbody>
            <tbody>
              <tr>
                <td className='text-center'>ทะเบียนรถ</td>
                <td className='text-center'></td>
                <td className='text-center bg-green'>{car.car_registration_no} {car.province}</td>
              </tr>
              <tr>
                <td className='text-center'>เจ้าของผู้รับรถ</td>
                <td className='text-center'></td>
                <td className='text-center'>{owner.name}</td>
              </tr>
              <tr>
                <td className='text-center color-pink'>บ.ประกันภัย</td>
                <td className='text-center color-pink'>{insurer.insurer_name}</td>
                <td className='text-center color-pink'>{car.car_type}</td>
              </tr>
              <tr>
                <td className='text-center'>รายการซ่อม</td>
                <td className='text-center'>ชนิดรถ</td>
                <td className='text-center'>เครดิต</td>
              </tr>
            </tbody>
            <tbody>
              <tr>
                <td className='text-center' rowSpan={7}>รายรับ</td>
                <td className='text-center'>ราคาประมูล</td>
                <td className='text-right bg-green' onClick={this.onClick.bind(this,'income','auction_price','ราคาประมูล',income.auction_price)}>{this.getNumberFormat(income.auction_price)}</td>
              </tr>
              <tr>
                <td className='text-center color-blue'>ราคายืนยัน</td>
                <td className='text-right bg-cream' onClick={this.onClick.bind(this,'income','price','ราคายืนยัน',income.price)}>{this.getNumberFormat(income.price)}</td>
              </tr>
              <tr>
                <td className='text-center'>ราคาเสนอ</td>
                <td className='text-right bg-blue' onClick={this.onClick.bind(this,'income','quotation_price','ราคาเสนอ',income.quotation_price)}>{this.getNumberFormat(income.quotation_price)}</td>
              </tr>
              <tr>
                <td className='text-center color-pink'>ราคาคุม</td>
                <td className='text-right bg-cream' onClick={this.onClick.bind(this,'income','final_price','ราคาคุม',income.final_price)}>{this.getNumberFormat(income.final_price)}</td>
              </tr>
              <tr>
                <td className='text-center color-blue'>รับเงินแล้ว</td>
                <td className='text-right' onClick={this.onClick.bind(this,'income','received_amount','รับเงินแล้ว',income.received_amount)}>{this.getNumberFormat(income.received_amount)}</td>
              </tr>
            </tbody>
            <tbody>
              <tr>
                <td className='text-center color-pink' rowSpan={17}>รายจ่าย</td>
                <td className='text-left color-pink'>ค่าแรงธุรการ + ค่าน้ำ + ค่าไฟ</td>
                <td className='text-right' onClick={this.onClick.bind(this,'expense','office_wage','ค่าแรงธุรการ + ค่าน้ำ + ค่าไฟ',expense.office_wage)}>{this.getNumberFormat(expense.office_wage)}</td>
              </tr>
              <tr>
                <td className='text-left'>ช่างรายวัน</td>
                <td className='text-right' onClick={this.onClick.bind(this,'expense','daily_wage','ช่างรายวัน',expense.daily_wage)}>{this.getNumberFormat(expense.daily_wage)}</td>
              </tr>
              <tr>
                <td className='text-left'>ช่างเบาะ</td>
                <td className='text-right' onClick={this.onClick.bind(this,'expense','seat_wage','ช่างเบาะ',expense.seat_wage)}>{this.getNumberFormat(expense.seat_wage)}</td>
              </tr>
              <tr>
                <td className='text-left'>ช่างไฟ</td>
                <td className='text-right' onClick={this.onClick.bind(this,'expense','eletronic_wage','ช่างไฟ',expense.eletronic_wage)}>{this.getNumberFormat(expense.eletronic_wage)}</td>
              </tr>
              <tr>
                <td className='text-left'>ช่างแอร์ + ติดฟิล์ม</td>
                <td className='text-right' onClick={this.onClick.bind(this,'expense','air_wage','ช่างแอร์ + ติดฟิล์ม',expense.air_wage)}>{this.getNumberFormat(expense.air_wage)}</td>
              </tr>
              <tr>
                <td className='text-left'>ช่างเครื่อง</td>
                <td className='text-right' onClick={this.onClick.bind(this,'expense','machine_wage','ช่างเครื่อง',expense.machine_wage)}>{this.getNumberFormat(expense.machine_wage)}</td>
              </tr>
              <tr>
                <td className='text-left'>ช่างเหมา</td>
                <td className='text-right' onClick={this.onClick.bind(this,'expense','contractor_wage','ช่างเหมา',expense.contractor_wage)}>{this.getNumberFormat(expense.contractor_wage)}</td>
              </tr>
              <tr>
                <td className='text-left'>ช่วงล่าง / เชื่อมกันชน</td>
                <td className='text-right' onClick={this.onClick.bind(this,'expense','suspension_wage','ช่วงล่าง / เชื่อมกันชน',expense.suspension_wage)}>{this.getNumberFormat(expense.suspension_wage)}</td>
              </tr>
              <tr>
                <td className='text-left'>ช่าง รื้อ + เคาะ + ประกอบ</td>
                <td className='text-right' onClick={this.onClick.bind(this,'expense','assemble_wage','ช่าง รื้อ + เคาะ + ประกอบ',expense.assemble_wage)}>{this.getNumberFormat(expense.assemble_wage)}</td>
              </tr>
              <tr>
                <td className='text-left'>ช่างสี</td>
                <td className='text-right' onClick={this.onClick.bind(this,'expense','paint_wage','ช่างสี',expense.paint_wage)}>{this.getNumberFormat(expense.paint_wage)}</td>
              </tr>
              <tr>
                <td className='text-left'>ช่างเหล็ก + ตัวถัง</td>
                <td className='text-right' onClick={this.onClick.bind(this,'expense','smith_wage','ช่างเหล็ก + ตัวถัง',expense.smith_wage)}>{this.getNumberFormat(expense.smith_wage)}</td>
              </tr>
              <tr>
                <td className='text-left'>ค่าแรงยิงทราย + รื้อ + ประกอบ</td>
                <td className='text-right' onClick={this.onClick.bind(this,'expense','sand_shot_wage','ค่าแรงยิงทราย + รื้อ + ประกอบ',expense.sand_shot_wage)}>{this.getNumberFormat(expense.sand_shot_wage)}</td>
              </tr>
              <tr>
                <td className='text-left color-blue'>ค่าอะไหล่</td>
                <td className='text-right' onClick={this.onClick.bind(this,'expense','part_price','ค่าอะไหล่',expense.part_price)}>{this.getNumberFormat(expense.part_price)}</td>
              </tr>
              <tr>
                <td className='text-left color-blue'>ค่าเหล็ก</td>
                <td className='text-right' onClick={this.onClick.bind(this,'expense','steel_price','ค่าเหล็ก',expense.steel_price)}>{this.getNumberFormat(expense.steel_price)}</td>
              </tr>
              <tr>
                <td className='text-left color-blue'>ค่าสี + วัสดุ</td>
                <td className='text-right' onClick={this.onClick.bind(this,'expense','color_price','ค่าสี + วัสดุ',expense.color_price)}>{this.getNumberFormat(expense.color_price)}</td>
              </tr>
              <tr>
                <td className='text-left color-blue'>ค่าน้ำมัน</td>
                <td className='text-right' onClick={this.onClick.bind(this,'expense','oil_price','ค่าน้ำมัน',expense.oil_price)}>{this.getNumberFormat(expense.oil_price)}</td>
              </tr>
              <tr>
                <td className='text-left color-blue'>อื่นๆ</td>
                <td className='text-right' onClick={this.onClick.bind(this,'expense','other','อื่นๆ',expense.other)}>{this.getNumberFormat(expense.other)}</td>
              </tr>
            </tbody>
            <tbody>
              <tr>
                <td className='text-center color-pink'>รวมคชจ.</td>
                <td className='text-center'></td>
                <td className='text-right bg-green'>{this.getExpenseAmount().toLocaleString(undefined, {maximumFractionDigits: 2})}</td>
              </tr>
              <tr>
                <td className='text-center color-blue'>รายได้อู่</td>
                <td className='text-center color-blue'>คงเหลือ</td>
                <td className='text-right'>{this.getProfit().toLocaleString(undefined, {maximumFractionDigits: 2})}</td>
              </tr>
              <tr>
                <td className='text-center'></td>
                <td className='text-center'></td>
                <td className='text-right'></td>
              </tr>
            </tbody>  
          </table>
          <div className='footer-page' style={{display:pdf_config.show_signature?'':'none'}}>
            <div>
              <table className='table table-print-car-summary-doc-2'>
                <tbody>
                  <tr>
                    <td className='text-center'>
                      <div>(........................................)</div>
                      <div>เจ้าหน้าที่จัดซื้อ</div>
                      <div>(สุวรรณภา ทาสันเทียะ)</div>
                      <div>จัดทำ</div>
                    </td>
                    <td className='text-center'>
                      <div>(........................................)</div>
                      <div>เจ้าหน้าที่บัญชี</div>
                      <div>(สุภาวดี ปราบวงษา)</div>
                    </td>
                    <td className='text-center'>
                      <div>(........................................)</div>                      
                      <div>รองผู้จัดการ</div>
                      <div>(นายไกรวิชญ์ พงษ์เกาะ)</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div>
              <table className='table table-print-car-summary-doc-2'>
                <tbody>
                  <tr>
                    <td className='text-center'>
                      <div>(........................................)</div>
                      <div>ผู้จัดการ</div>
                      <div>(นาย สมเดช เรตสันเทียะ)</div>
                      <div>รับทราบ</div>
                    </td>
                    <td className='text-center'>
                      <div>(........................................)</div>
                      <div>กรรมการผู้จัดการ</div>
                      <div>(นาย เกษม พงษ์เกาะ)</div>
                      <div>รับทราบ</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <TextFieldModal ref='textFieldModal'
          confirmTitle='บันทึก'
          onConfirm={this.onOtherSave.bind(this)}
        />
        <NotificationSystem ref="notificationSystem" />
      </div>
    )
  }  

  getValid(value) {
    if (value===undefined||value===null||value==='') {
      return 0
    }
    value = value.replace(",", "");

    if(isNaN(value)===true){
      value = 0
    }
    return value
  }

  getExpenseAmount() {
    let expense = this.state.data.summary.expense
    let sum_expense = 0
    let office_wage = expense.office_wage
    office_wage = this.getValid(office_wage)
    let daily_wage = expense.daily_wage
    daily_wage = this.getValid(daily_wage)
    let seat_wage = expense.seat_wage
    seat_wage = this.getValid(seat_wage)
    let eletronic_wage = expense.eletronic_wage
    eletronic_wage = this.getValid(eletronic_wage)
    let air_wage = expense.air_wage
    air_wage = this.getValid(air_wage)
    let machine_wage = expense.machine_wage
    machine_wage = this.getValid(machine_wage)
    let contractor_wage = expense.contractor_wage
    contractor_wage = this.getValid(contractor_wage)
    let suspension_wage = expense.suspension_wage
    suspension_wage = this.getValid(suspension_wage)
    let assemble_wage = expense.assemble_wage
    assemble_wage = this.getValid(assemble_wage)
    let paint_wage = expense.paint_wage
    paint_wage = this.getValid(paint_wage)
    let smith_wage = expense.smith_wage
    smith_wage = this.getValid(smith_wage)
    let sand_shot_wage = expense.sand_shot_wage
    sand_shot_wage = this.getValid(sand_shot_wage)
    let part_price = expense.part_price
    part_price = this.getValid(part_price)
    let steel_price = expense.steel_price
    steel_price = this.getValid(steel_price)
    let color_price = expense.color_price
    color_price = this.getValid(color_price)
    let oil_price = expense.oil_price
    oil_price = this.getValid(oil_price)
    let other = expense.other
    other = this.getValid(other)
    sum_expense = parseInt(office_wage)+parseInt(daily_wage)+parseInt(seat_wage)+parseInt(eletronic_wage)+parseInt(air_wage)+parseInt(machine_wage)+parseInt(contractor_wage)+parseInt(suspension_wage)+parseInt(assemble_wage)+parseInt(paint_wage)+parseInt(smith_wage)+parseInt(sand_shot_wage)+parseInt(part_price)+parseInt(steel_price)+parseInt(color_price)+parseInt(oil_price)+parseInt(other)
    return sum_expense
  }

  getProfit() {
    let {insurer} = this.state.data  
    let income = this.state.data.summary.income
    let sum_income = 0
    let final_price = (insurer.insurer_id*1===0)?income.price:income.final_price
    

    final_price = this.getValid(final_price)
    sum_income = final_price - this.getExpenseAmount()
    return sum_income
  }

  saveCarSummaryDoc(data) {
    let {workNo} = this.props
    let that = this

    WorkdocStore.saveWorkdocRelated(workNo,'car_summary_doc',data.related_detail,function(result){
      that._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'ทำการบันทึกรายละเอียดใบสรุปงาน ' + workNo + ' เรียบร้อย',
        level: 'info',
        position: 'tc',        
      });
    },function(){
      that._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'มีความผิดพลาดเกิดขึ้นในการบันทึก ' + workNo + ' ',
        level: 'error',
        position: 'tc'
      });
    })
  }

  onOtherSave(fieldInfo){
    let {data} = this.state
    let value = this.getValid(fieldInfo.value)

    data['related_detail'] = data.summary
    data['related_detail'][fieldInfo.type][fieldInfo.key] = value
    data['related_detail']['expense_amount'] = this.getExpenseAmount()
    data['related_detail']['profit'] = this.getProfit()
    this.setState({data:data})
    this.saveCarSummaryDoc(data)
  }

  onClick(type,key,key_thai,value,e){
    let fieldInfo = {title:'ใส่ข้อมูล'+key_thai,showClear:true,value:value,type:type,key:key}
    this.refs.textFieldModal.loadInfo(fieldInfo)
  }      

  render(){
    let {loading} = this.state
    return (
      <PrintPreview loading={loading} leftBarTitle={'ใบงานหมายเลข '+this.props.workNo}>
        {this.renderComponentPage()}  
      </PrintPreview>
    )
  }
}  

PrintCarSummaryDoc.defaultProps = {
  title: '',  
  mode : '',
  workNo : ''
}
export default PrintCarSummaryDoc;


// WEBPACK FOOTER //
// ./src/view/print/PrintCarSummaryDoc.js